import type {
	ConnectCustomerType,
	ConnectErrorDescription,
} from 'models/connect/oauth';
import type { CamelCaseKeys, DecodedUserJWTToken } from 'types';

export type IntrospectionResponse = CamelCaseKeys<
	Pick<
		DecodedUserJWTToken,
		| 'contact_id'
		| 'contact_role'
		| 'customer_contact_id'
		| 'customer_ext_voyado'
		| 'customer_type'
		| 'given_name'
	>
>;

export interface OauthStateParam {
	customerType: ConnectCustomerType;
	protectedRouteReturnPath?: string;
	redirectPath: string;
}

export type OIDCError =
	| 'internal-error-token'
	| 'internal-error-unknown'
	| ConnectErrorDescription;

export const JULA_CONNECT_AUTHORIZE_DEFAULT_SCOPE =
	'openid offline_access digitalplatform.basic';
